import { type Primitive } from "type-fest";

export type NullSanitized<T> = T extends (infer U)[]
  ? NullSanitized<U>[]
  : T extends object
    ? { [Key in keyof T]: NullSanitized<T[Key]> }
    : T extends Primitive
      ? Exclude<T, null>
      : T extends null
        ? undefined
        : never;

// ?: does it make sense to remove `null` from all incoming DTOs?
/** Change null fields to undefined and make typescript happy. Our generated types always include null because of some shortcoming with the auto-generated openapi spec from the backend. */
export function sanitizeDto<T extends unknown | object | object[] | Primitive | Primitive[]>(
  value: T,
): NullSanitized<T>;

/** Change null fields to undefined and make typescript happy. Our generated types always include null because of some shortcoming with the auto-generated openapi spec from the backend. */
export function sanitizeDto<T>(value: T) {
  if (value === null) {
    return undefined;
  }

  if (typeof value !== "object") {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(sanitizeDto);
  }

  return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, sanitizeDto(v)]));
}

export function valueOrFallback<T>(value: T | null | undefined, fallback: T, message?: string) {
  if (!value) {
    console.error(message ?? "(sanitizeDto)(valueOrFallback) value is null or undefined. using fallback value.");
    return fallback;
  }

  return value;
}
